module.exports = __webpack_public_path__ + "img/LinuxUbuntu.ecc7639f.webp";